import { HttpService } from '@/utils/http/index'

const $http = new HttpService()

/**
 * 获取全局菜单提醒数据
 * @param params
 */
export const getMenuWarningApi = (params:object = {}) => $http.get('/admin/brands/get_new_msg?type=1', {...params, notShowLoading: true})

// 发送验证码
export const sendCode = (phone: string) => $http.post('/cake_api/send_msg', { phone })

// 发送验证码--不用传手机号，后台自动获取当前登录用户绑定的手机号
export const sendCodeWithoutPhone = () => $http.get('/couponBatch/send_msg')

/**
 * 根据详细地址获取省、市、区/县、经纬度
 * @param params
 */
export const getParseAddrApi = (addr_name: string) => $http.get('/cake_api/shop/get_shop_lat', { addr_name })

/**
 * 获取宜搭用户列表
 * @param params
 */
export const getDingtalkUserListApi = () => $http.get('/couponBatch/get_sell_user')
